import { Button } from '@/components/ui/button';
import AssetSupportIcon from '../assets-action-bar/icons/AssetSupportIcon';

type RequestSupportButtonProps = {
  onOpenSupportRequest: () => void;
  /**
   * 'tab-row': ghost text+icon at the right end of the desktop tab row
   * (2026-08-19 design update — settles the placement question).
   * 'icon': icon-only Button for the sub-lg control row (deviation from the
   * design's kebab entry, recorded in spec §1.5's correction: the icon keeps
   * Request Support reachable on Zillow's disabled kebab and on Trash,
   * which has no kebab).
   */
  variant: 'tab-row' | 'icon';
};

const RequestSupportButton = ({ onOpenSupportRequest, variant }: RequestSupportButtonProps) => {
  if (variant === 'tab-row') {
    return (
      <Button
        variant="ghost"
        type="button"
        onClick={onOpenSupportRequest}
        className="shrink-0 font-semibold"
      >
        Request Support
        <AssetSupportIcon />
      </Button>
    );
  }
  return (
    <Button
      variant="outline"
      size="icon"
      type="button"
      aria-label="Request Support"
      tooltip="Request Support"
      onClick={onOpenSupportRequest}
      className="border-input shrink-0"
    >
      <AssetSupportIcon />
    </Button>
  );
};

export default RequestSupportButton;
